import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { showConfirm, closeConfirm, setLoading as setLoadingAction } from '../redux/slices/confirmSlice';

export function useConfirm() {
  const state = useSelector((state) => state.confirm);
  const dispatch = useDispatch();

  const confirm = useCallback((data) => {
    dispatch(showConfirm(data));
  }, []);

  const close = useCallback(() => {
    dispatch(closeConfirm());
  }, []);

  const setLoading = useCallback((value) => {
    dispatch(setLoadingAction(value));
  }, []);

  return { confirm, close, setLoading, state };
}